import React from "react";

import "./App.css";
import { ZoomMtg } from "@zoom/meetingsdk";

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();

function App() {
  const [enableSAB, setEnableSAB] = React.useState("unknown");
  var authEndpoint = process.env.REACT_APP_ZOOM_AUTH_ENDPOINT;
  var sdkKey = process.env.REACT_APP_ZOOM_SDK_KEY;
  // var meetingNumber = process.env.REACT_APP_ZOOM_MEETING_NUMBER;
  var meetingNumber = "";
  var passWord = "";
  var role = 0;
  var userName = "";
  var userEmail = "";
  var registrantToken = "";
  var zakToken = "";
  var leaveUrl = "http://localhost:3000";

  React.useEffect(() => {
    const _enableSAB = typeof SharedArrayBuffer === "function";
    console.log("SharedArrayBuffer enabled:", _enableSAB);
    setEnableSAB(_enableSAB ? "enabled" : "disabled");
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    console.log("handleOnSubmit", e.target);

    userName = document.getElementById("name").value;
    userEmail = document.getElementById("email").value;
    meetingNumber = document.getElementById("meetingId").value;
    passWord = document.getElementById("passcode").value;

    getSignature(e);
  };

  function getSignature(e) {
    e.preventDefault();

    // console.log("XXX authEndpoint", authEndpoint);
    // console.log("XXX sdkKey", sdkKey);
    // console.log("XXX meetingNumber", meetingNumber);

    fetch(authEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        meetingNumber: meetingNumber,
        role: role,
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        startMeeting(response.signature);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function startMeeting(signature) {
    document.getElementById("zmmtg-root").style.display = "block";

    ZoomMtg.init({
      leaveUrl: leaveUrl,
      patchJsMedia: true,
      success: (success) => {
        console.log(success);

        ZoomMtg.join({
          signature: signature,
          sdkKey: sdkKey,
          meetingNumber: meetingNumber,
          passWord: passWord,
          userName: userName,
          userEmail: userEmail,
          tk: registrantToken,
          zak: zakToken,
          success: (success) => {
            console.log(success);
          },
          error: (error) => {
            console.log(error);
          },
        });
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  return (
    <div className="App">
      <main>
        <h1>Zoom Meeting SDK Sample React</h1>
        <b>SharedArrayBuffer: {enableSAB}</b>
        <br />
        <br />
        <form onSubmit={handleOnSubmit}>
          <div>
            <label for="name">Username:</label>
            {"  "}
            <input name="name" id="name" type="textfield"></input>
          </div>
          <div>
            <label for="email">Email:</label>
            {"  "}
            <input name="email" id="email" type="textfield"></input>
          </div>
          <div>
            <label for="meetingId">Meeting Id:</label>
            {"  "}
            <input name="meetingId" id="meetingId" type="textfield"></input>
          </div>
          <div>
            <label for="passcode">Meeting Passcode:</label>
            {"  "}
            <input name="passcode" id="passcode" type="password"></input>
          </div>
          <br />
          {/* <button onClick={getSignature}>Join Meeting</button> */}
          <button type="submit">Join Meeting</button>
        </form>
      </main>
    </div>
  );
}

export default App;
